<template>
    <MypageVisit
        :page_title="page_title"
        :icon_class="icon_class"
        :show_error.sync="show_error"
        :error_message="error_message"
        :error_level="error_level"
        :my_page_btn_flg="my_page_btn_flg"

        :golf_course="golf_course"
        :show_golf_list_flg="show_golf_list_flg"
        :selectGolf="selectGolf"
        :show_golf_list_count_flg="show_golf_list_count_flg"
    >
        <!-- 以下内容 -->
        <div class="col-sm-12 p-0">
            <div class="col-sm-12">

                <p class="text-left mt-3 h4 visit-h3-boder-left">ご利用ゴルフ場</p>
                <template v-if="show_golf_list_count_restaurant_flg == true">
                    <label class="text-left my-2 ">ご利用になるゴルフ場をクリックしてください。</label>

                    <div class="col-12 p-0 mt-4">
                        <template v-for="data in golf_course" >
                            <template v-if="data.api_restaurant_url != undefined && data.api_restaurant_url != '' && data.api_restaurant_url != null">
                                <button
                                    type="button"
                                    class="visit-golf-list-btn py-2 px-2 m-0 mb-3 row"
                                    @click="selectGolfRestaurant(data.api_restaurant_url)"
                                    :key="data.golf_code"
                                >

                                    <div class="visit-golf-list-name p-0">
                                        <p class="h5">{{data.golf_name}}</p>
                                    </div>
                                    <div class="visit-golf-list-info row m-0 p-0">
                                        <div class="visit-golf-list-img p-0" v-show="( data.golf_course_img_path != undefined && data.golf_course_img_path != '' && data.golf_course_img_path != null )">
                                            <img :src="data.golf_course_img_path">
                                        </div>
                                        <div class="visit-golf-list-address row m-0 p-0 pl-2 text-left" v-bind:class="{ 'golf_no_image' : ( data.golf_course_img_path == undefined || data.golf_course_img_path == '' || data.golf_course_img_path == null ) }">

                                            <div class="visit-golf-list-add">
                                                <label class="px-2 m-0 text-light label-color">住所</label>
                                                <p class="mb-2">{{data.prefecture_name}}{{data.municipality_name}}{{data.local_name}}{{data.building_name}}</p>
                                            </div>

                                            <div class="visit-golf-list-tel">
                                                <label class="px-2 m-0 text-light label-color">電話番号</label>
                                                <p class="mb-2">{{data.telephone}}</p>
                                            </div>

                                        </div>

                                        <div class="visit-golf-list-arrow">
                                            <div class="visit-arrow-icon"></div>
                                        </div>
                                    </div>

                                </button>
                            </template>
                        </template>
                    </div>
                </template>
                <template v-else>
                    <label class="text-left my-3">ご利用になれるゴルフ場がありません。</label>
                </template>

                <button
                    type="button"
                    class="my-3 mypagebackbutton footer-btn-size"
                    @click="myPage">
                    マイページトップに戻る
                </button>
            </div>
        </div>
    </MypageVisit>
</template>

<script>
/**
 * マイページ レストランオーダー
 * */

// 共通画面項目
import MypageVisit from '../components/MyPage/MypageVisit';
// 共通JS項目
import mypageVisitMixin from '../../mixins/MyPage/mypageVisitMixin.js';
import validater from "../../lib/validater";

export default {
    components: {
        MypageVisit,
        validater
    },
    mixins: [
        mypageVisitMixin
    ],
    data () {
        return {
        };
    },
    // 画面作成前
    created () {
        this.page_title = 'レストランオーダー';
        this.icon_class = 'icon-icon-info-profile mypage-title-icon';
    },
    // 画面値更新時
    computed: {
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize() {
        },
        /** ----------------------------------------------
         * APIを使用し、データを取得
         * ---------------------------------------------- */
        selectGolfRestaurant: function(api_restaurant_url){
            //新しいタブでサイトを開く
            window.open( api_restaurant_url );
        },
    },
}
</script>
